"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.type4Fields = void 0;
exports.type4Fields = {
    LogicalRecordLengthT4: {
        label: 'Logical Record Length',
        minLength: 2,
        maxLength: 8,
        desc: 'This mandatory four-byte binary field shall occupy bytes one through four of each record type. It  shall contain the length of the logical record specifying the total number of bytes, including every  byte of all nine fields contained in the record.',
        EBTS: {
            mnemonic: 'T4_LEN',
            index: '4.01...0',
            dataType: 'B4'
        },
        required: false
    },
    ImageDesignationCharacterT4: {
        label: 'Image Designation Character',
        minLength: 1,
        maxLength: 2,
        desc: 'This mandatory one-byte binary field shall occupy the fifth byte of each record type. It shall be  used to identify the image data contained in this record. The IDC contained in this field shall be a  binary representation of the IDC found in the file content (CNT) field of the Type-1 record.',
        EBTS: {
            mnemonic: 'T4_IDC',
            index: '4.02...4',
            dataType: 'B1'
        },
        required: false
    },
    ImpressionType: {
        label: 'Impression Type',
        minLength: 1,
        maxLength: 1,
        options: [
            ['0', 'Live-scan Plain'],
            ['1', 'Live-Scan Rolled'],
            ['2', 'Nonlive-scan Plain'],
            ['3', 'Nonlive-scan Rolled'],
            ['4', 'Latent Impression'],
            ['5', 'Latent Tracing'],
            ['6', 'Latent Photo'],
            ['7', 'Latent Lift'],
            ['8', 'Live-scan vertical swipe'],
            ['10', 'Live-scan palm'],
            ['11', 'Nonlive-scan palm'],
            ['12', 'Latent palm impression'],
            ['13', 'Latent palm tracing'],
            ['14', 'Latent palm photo'],
            ['15', 'Latent palm lift'],
            ['20', 'Live-scan optical contact plain'],
            ['21', 'Live-scan optical contact rolled'],
            ['22', 'Live-scan non-optical contact plain'],
            ['23', 'Live-scan non-optical contact rolled'],
            ['24', 'Live-scan optical contactless plain'],
            ['25', 'Live-scan optical contactless rolled'],
            ['26', 'Live-scan non-optical contactless plain'],
            ['27', 'Live-scan non-optical contactless rolled'],
            ['28', 'Other'],
            ['29', 'Unknown']
        ],
        desc: 'This mandatory one byte binary field shall occupy the sixth byte of each record type. The code  selected from Table 11, describing the manner by which the fingerprint image information was  obtained, shall be entered in this field.',
        EBTS: {
            mnemonic: 'T4_IMP',
            index: '4.03...5',
            dataType: 'B1'
        },
        required: false
    },
    FingerPosition: {
        label: 'Finger Position',
        minLength: 1,
        maxLength: 3,
        maxOccurrences: 6,
        options: [
            ['0', 'Unknown Finger'],
            ['1', 'Right Thumb'],
            ['2', 'Right Index Finger'],
            ['3', 'Right Middle Finger'],
            ['4', 'Right Ring Finger'],
            ['5', 'Right Little Finger'],
            ['6', 'Left Thumb'],
            ['7', 'Left Index Finger'],
            ['8', 'Left Middle Finger'],
            ['9', 'Left Ring Finger'],
            ['10', 'Left Little Finger'],
            ['11', 'Plain Right Thumb'],
            ['12', 'Plain Left Thumb'],
            ['13', 'Plain Right Four Fingers'],
            ['14', 'Plain Left Four Fingers'],
            ['255', 'Empty']
        ],
        desc: "This mandatory fixed-length field of six binary bytes shall occupy the seventh through twelth byte  positions of each record type. It shall contain possible finger positions beginning in the leftmost  byte of the field (byte seven of the record). The decimal code number corresponding to the  known or most probable finger position shall be taken from Table 12 (only finger numbers 0-14  apply to Types 3-6) and entered as a binary number right justified and left zero filled within the  eight-bit byte. Table 12 also lists the maximum image width and height dimensions for each of  the finger positions. Up to five additional finger positions may be referenced by entering the  alternate finger positions in the remaining five bytes using the same format.  If fewer than five finger position references are to be used, the unused bytes shall be filled with  the binary equivalent of '255'. The code '0', for 'Unknown Finger', shall be used to reference  every finger position from one through ten.",
        EBTS: {
            mnemonic: 'T4_FGP',
            index: '4.04...6',
            dataType: 'B1'
        },
        required: false
    },
    ImageScanningResolution: {
        label: 'Image Scanning Resolution',
        minLength: 1,
        maxLength: 1,
        options: [
            ['0', 'Minimum Scanning Resolution'],
            ['1', 'Native Scanning Resolution']
        ],
        desc: "This mandatory one-byte binary field shall occupy the thirteenth byte of each record type.  It shall contain a binary value of '0' if the minimum  scanning resolution is used and a '1' if the native scanning resolution is used.",
        EBTS: {
            mnemonic: 'T4_ISR',
            index: '4.05...12',
            dataType: 'B1'
        },
        required: false
    },
    HorizontalLineLength: {
        label: 'Horizontal Line Length',
        minLength: 1,
        maxLength: 5,
        desc: 'This field shall be used to specify the number of  pixels contained on a single horizontal line of the  transmitted image.',
        EBTS: {
            mnemonic: 'T4_HLL',
            index: '4.06...13',
            dataType: 'B2'
        },
        required: false
    },
    VerticalLineLength: {
        label: 'Vertical Line Length',
        minLength: 1,
        maxLength: 5,
        desc: 'This field should be used to specify the number of  vertical lines contained in the transmitted image.',
        EBTS: {
            mnemonic: 'T4_VLL',
            index: '4.07...15',
            dataType: 'B2'
        },
        required: false
    },
    GrayscaleCompressionAlgorithm: {
        label: 'Grayscale Compression Algorithm',
        minLength: 1,
        maxLength: 3,
        desc: 'This field should be used to specify the type of  gray-scale compression algorithm used. A 0 denotes  no compression. Otherwise a number will be allocated  to the particular compression technique used by the  interchange parties. A 1 denotes  CJIS WSQ compression.',
        EBTS: {
            mnemonic: 'T4_GCA',
            index: '4.08...17',
            dataType: 'B1'
        },
        required: false
    },
    ImageData: {
        label: 'Image Data',
        minLength: 1,
        desc: 'This field contains the image data.',
        EBTS: {
            mnemonic: 'T4_DAT',
            index: '4.09...18',
            dataType: 'B1'
        },
        required: false
    }
};
//# sourceMappingURL=jfd.type4.js.map